var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { operationTypes } from '../../../constants/constants.js';
import moment from 'moment';
import { injectIntl } from 'react-intl';
var messages = defineMessages({
    ringoGames_bet_result: {
        id: 'member-area.operation_type_4',
        defaultMessage: 'Выигрыш RingoGames'
    },
    ringoGames_bet: {
        id: 'member-area.operation_type_3',
        defaultMessage: 'Ставка RingoGames'
    },
    bonus: {
        id: 'member-area.operation_type_5',
        defaultMessage: 'Начисление бонуса'
    },
    deposit: {
        id: 'member-area.operation_type_7',
        defaultMessage: 'Пополнение счета'
    },
    withdrawal: {
        id: 'member-area.operation_type_8',
        defaultMessage: 'Снятие средств'
    },
    account_correction: {
        id: 'member-area.operation_type_6',
        defaultMessage: 'Коррекция счета'
    },
    payment_out: {
        id: 'member-area.history_account_table_payment_out',
        defaultMessage: 'Расход'
    },
    payment_in: {
        id: 'member-area.history_account_table_payment_in',
        defaultMessage: 'Приход'
    },
    odd: {
        id: 'member-area.history_account_table_payment_odd',
        defaultMessage: 'Цена'
    },
    amount: {
        id: 'member-area.history_account_table_payment_amount',
        defaultMessage: 'Кол-во'
    },
    combobet_stake: {
        id: 'member-area.history_account_table_combobet_stake',
        defaultMessage: 'Ставка(BetGames)'
    },
    combobet_stake_won: {
        id: 'member-area.history_account_table_combobet_stake_won',
        defaultMessage: 'Результат(BetGames)'
    }
});
var AccHistoryInfo = function (props) {
    var operationsData = props.operationsData, type = props.type;
    var transactionAmount = operationsData.TransactionAmount;
    var date = operationsData.Date;
    var msg;
    var transactionTypeMsg;
    switch (type) {
        case operationTypes.DEPOSIT:
            msg = _jsx(FormattedMessage, __assign({}, messages.deposit));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.WITHDRAWAL:
            msg = _jsx(FormattedMessage, __assign({}, messages.withdrawal));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.RINGOGAMES_STAKE:
            msg = _jsx(FormattedMessage, __assign({}, messages.ringoGames_bet));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.RINGOGAMES_STAKE_PAYMENT:
            msg = _jsx(FormattedMessage, __assign({}, messages.ringoGames_bet_result));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.ACCOUNT_CORRECTION:
            msg = _jsx(FormattedMessage, __assign({}, messages.account_correction));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.BONUS:
            msg = _jsx(FormattedMessage, __assign({}, messages.bonus));
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.COMBOBET_STAKE:
            msg = 'Total/37';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.COMBOBET_STAKE_WON:
            msg = 'Total/37';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.BETGAMES_STAKE:
            msg = 'BetGames';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.BETGAMES_STAKE_PAYMENT:
            msg = 'BetGames';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.HOLLYWOOD_TV_STAKE:
            msg = 'Hollywood TV';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.HOLLYWOOD_TV_STAKE_PAYMENT:
            msg = 'Hollywood TV';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.VIVO_STAKE:
            msg = 'VIVO Gaming';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.VIVO_STAKE_PAYMENT:
            msg = 'VIVO Gaming';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.BETSOLUTIONS_STAKE:
            msg = 'Betsolutions';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.BETSOLUTIONS_STAKE_PAYMENT:
            msg = 'Betsolutions';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.TVBET_STAKE:
            msg = 'TVBET';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.TVBET_STAKE_PAYMENT:
            msg = 'TVBET';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.DATABET_STAKE:
            msg = 'DATABET';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.DATABET_STAKE_PAYMENT:
            msg = 'DATABET';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.XPRESS_STAKE:
            msg = 'XPRESS';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.XPRESS_STAKE_PAYMENT:
            msg = 'XPRESS';
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        case operationTypes.VIRTUAL_SPORTS:
            msg = props.intl.formatMessage({ id: 'games.virtual-sport' });
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_out));
            break;
        case operationTypes.VIRTUAL_SPORTS_PAYMENT:
            msg = props.intl.formatMessage({ id: 'games.virtual-sport' });
            transactionTypeMsg = _jsx(FormattedMessage, __assign({}, messages.payment_in));
            break;
        default:
            break;
    }
    return (_jsxs("div", __assign({ className: 'item' }, { children: [_jsx("div", __assign({ className: 'header' }, { children: _jsxs("div", __assign({ className: 'title' }, { children: [msg, " ", moment(date).format('DD.MM.YYYY HH:mm')] })) })), _jsx("table", { children: _jsx("tbody", { children: _jsx("tr", { children: _jsxs("td", __assign({ style: { padding: '5px 10px' } }, { children: [transactionTypeMsg, ": ", _jsx("strong", { children: transactionAmount })] })) }) }) })] })));
};
AccHistoryInfo.propTypes = {
    type: PropTypes.number.isRequired,
    operationsData: PropTypes.object.isRequired
};
export default injectIntl(AccHistoryInfo);



// WEBPACK FOOTER //
// ./src/components/account-history/items/AccHistoryInfo.jsx